import { NavLink, Outlet } from "react-router-dom";
import { Brandmark } from "../../components/Brandmark.js";
import { Icon } from "../../components/Icon.js";
import { useUser } from "../../auth/UserContext.js";
import { logoutUrl } from "../../auth/authClient.js";
import type { ParentBundle } from "../../api/me.js";

const TABS: ReadonlyArray<{ id: string; label: string; icon: string }> = [
  { id: "dashboard", label: "Family dashboard", icon: "home" },
  { id: "activity", label: "All activity", icon: "history" },
  { id: "settings", label: "Settings", icon: "settings" },
];

export default function ParentLayout() {
  const { bundle } = useUser();
  if (!bundle || bundle.user.role !== "parent") return null;
  const parent = bundle as ParentBundle;

  const onLogout = () => {
    window.location.href = logoutUrl();
  };

  const initial = parent.user.name[0] ?? "?";

  return (
    <div className="app">
      <div className="topbar">
        <div className="topbar-brand">
          <Brandmark />
          KBank{" "}
          <span className="chip brand" style={{ marginLeft: 8 }}>
            Parent
          </span>
        </div>
        <div className="topbar-user">
          <div className="topbar-greet">
            <span className="small">Signed in as</span>
            <span className="name">{parent.user.name}</span>
          </div>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              background: "oklch(0.92 0.01 240)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "Fraunces, serif",
              fontSize: 18,
            }}
          >
            {initial}
          </div>
          <button className="btn btn-ghost btn-sm" onClick={onLogout}>
            <Icon name="logout" size={16} />
            Sign out
          </button>
        </div>
      </div>

      <div className="nav">
        {TABS.map((t) => (
          <NavLink key={t.id} to={t.id} className={({ isActive }) => (isActive ? "active" : "")}>
            <Icon name={t.icon} size={16} />
            {t.label}
          </NavLink>
        ))}
      </div>

      <div className="main fadein">
        <Outlet />
      </div>
    </div>
  );
}
